import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, Download, Eye, Printer, MessageCircle } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5 } from "../../../AbstractElements";
import axios from "axios";
import { FontSize } from "../../../Constant";

const user_options = ["Name", "Province", "District"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
}) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
    <input
      className="form-control"
      placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province") : t("Filter by Status") }
      aria-label="Search Input"
      style={{ width: "250px", paddingLeft: "5px" }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn attrBtn={{ onClick: onClear }} type="button">
      X
    </Btn>
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [user_id, setUserId] = useState();
  const { t } = useTranslation();
  const pres = localStorage.getItem("pres");
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Name");
  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
  }, []);

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        "https://api-portal.nada.org.np/api/firms?status=1",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response2?.data?.success) {
        const firms = response2?.data?.data?.firms;
        setData(firms);
        setFilteredItems(firms);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete:\r ${selectedRows.map((r) => r.name)}?`
      )
    ) {
      setToggleCleared(!toggleCleared);
      setData(differenceBy(data, selectedRows, "name"));
      toast.success("Successfully Deleted !");
    }
  };

  /*const handlePrint = (imageUrl, e) => {
    e.preventDefault();
    var link = "https://d24xzirvx50zjt.cloudfront.net/" + imageUrl;
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>Print Image</title>
                <style>
                    body { margin: 0; display: flex; justify-content: center; align-items: center; }
                    img { max-width: 100%; height: auto; }
                </style>
            </head>
            <body onload="window.print(); window.close();">
                <img src="${link}" alt="Printable Image" />
            </body>
        </html>
    `);
    printWindow.document.close();
};*/


const handlePrint = (imageUrl, e) => {
  e.preventDefault();
    var link = "https://d24xzirvx50zjt.cloudfront.net/" + imageUrl;
  const printWindow = window.open('', '_blank');
  printWindow.document.open();
  printWindow.document.write(`
      <html>
          <head>
              <title>Print PDF</title>
              <style>
                  body { margin: 0; display: flex; justify-content: center; align-items: center; }
                  iframe { width: 100%; height: 100vh; border: none; }
              </style>
          </head>
          <body onload="window.print(); window.close();">
              <iframe src="${link}" type="application/pdf"></iframe>
          </body>
      </html>
  `);
  printWindow.document.close();
};

// Function to download the image
const handleDownload = async (imageUrl, e) => {
  e.preventDefault();
    try {
      var link = "https://d24xzirvx50zjt.cloudfront.net/" + imageUrl;
        const response = await fetch(link);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = link.split('/').pop() || 'image.png'; // Extract file name from URL
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
        console.error('Error downloading image:', error);
    }
};

  const handleClick = async (num, name, e) => {
    e.preventDefault();
    try {
    const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/users/send-reminder",
          {
            phone_number: num,
            name_of_firm: name,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response2?.data?.success) {
          toast.success(response2?.data?.message);
        }
      } catch (error) {
        if (error.response) {
          console.error("Error response:", error.response);
          toast.error(error.response.data.message || "An error occurred");
        } else if (error.request) {
          console.error("Error request:", error.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error.message);
          toast.error(error.message);
        }
      }
  };

  function ComponentEdit({ row }) {
    return (
      <span style={{ display: "flex", flexDirection: "row", gap: 15, cursor: 'pointer' }}>
        <Btn
                    attrBtn={{ color: "secondary", onClick: (e) => handleClick(row?.contact_person_num, row?.name_of_firm, e) }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Send SMS Reminder")}
                    </Btn>
        {/*<div
          onClick={(e) => {
            handleClick(row?.contact_person_num, row?.name_of_firm, e);
          }}
        >
          Send Reminder
        </div>*/}
      </span>
    );
  }

  const handleAddNewClick = () => {
    navigate("/proxy/add");
  };

  const renderStatusBadge = (status) => {
    if (status === 1) {
      return <p>new membership</p>;
    } else if (status === 2) {
      return <p>Renew membership</p>;
    } else {
      return <p>AGM</p>;
    }
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };


  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Date"),
      selector: (Row) => Row["expiry_date"],
      sortable: true,
      center: true,
    },
    { name: t("Actions"), cell: (row) => <ComponentEdit row={row} /> }
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_firm
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : data?.filter((item) =>
            String(item?.status === 1? 'Submitted' : item?.status === 2?  'Send For Edits' : item?.status === 3?  'Accepted' : item?.status === 4?  'Rejected' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Payment Due")}</H5>
                {/*
                  <Btn
                    attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Add New
                  </Btn>
                */}
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default DataTablesContain;
